import { render, staticRenderFns } from "./CommonCodeDetail.vue?vue&type=template&id=3212de3c&scoped=true"
import script from "./CommonCodeDetail.vue?vue&type=script&lang=js"
export * from "./CommonCodeDetail.vue?vue&type=script&lang=js"
import style0 from "./CommonCodeDetail.vue?vue&type=style&index=0&id=3212de3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3212de3c",
  null
  
)

export default component.exports